/* unplugin-vue-components disabled */import __unplugin_components_2 from '/var/repos/bic-vue/src/components/configurator/sidebar/drawer/Drawer.vue';
import __unplugin_components_1 from '/var/repos/bic-vue/src/components/configurator/ConfiguratorWrapper.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/configurator/sidebar/ConfiguratorSidebar.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "relative flex h-full"
};
import { useConfigurationStore } from '@/stores/configurationModule';
export default {
  __name: 'Configurator',
  setup(__props) {
    const configurationStore = useConfigurationStore();
    const {
      box
    } = storeToRefs(configurationStore);
    const hasBox = computed(() => {
      const {
        width,
        length,
        depth
      } = box.value;
      return width && length && depth;
    });
    return (_ctx, _cache) => {
      const _component_ConfiguratorSidebar = __unplugin_components_0;
      const _component_ConfiguratorWrapper = __unplugin_components_1;
      const _component_Drawer = __unplugin_components_2;
      return _openBlock(), _createBlock(_component_Drawer, {
        class: "h-full"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_ConfiguratorSidebar), _unref(hasBox) ? (_openBlock(), _createBlock(_component_ConfiguratorWrapper, {
          key: 0
        })) : _createCommentVNode("", true)])]),
        _: 1
      });
    };
  }
};